import React from "react";

import { Link } from "react-router-dom";
import "./PageNotFound.css";

const PageNotFound = () => {
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <body className="g-sidenav-show  bg-gray-200 err_bg">
          <div class="mainbox">
            <div class="err">4</div>
            <div class="err0">0</div>
            <div class="err2">4</div>
            <div class="msg">
              {/* <p>
                <Link to="/" class="btn-primary blue_btn">
                  home
                </Link>{" "}
              </p> */}
            </div>
          </div>
        </body>
      </main>
    </>
  );
};

export default PageNotFound;
